export default __webpack_public_path__ + "static/media/PaintingPenArtSchool-2.d8bcdf1d.jpg";